import { VENDOR_PAYMENTS } from "./Url";

export const vendorSeoKeywords = [
  "Vendor Payments",
  "Vendor Payouts",
  "Invoice payments",
  "Vendor payment processing",
  "Accounts payables",
  "Vendor payment system",
  "Accounts processing",
  "Invoice processing",
  "Accounts payable process",
  "payment process",
  "vendor invoices",
  "Merchant payment",
  "Vendor payable",
  "smart verify vendor",
  "cycle accounting",
  "trade payables",
  "vendor reconciliation",
];

export const vendorData = [
  {
    src: `${VENDOR_PAYMENTS}/Finance.png`,
    alt: "img",
    text: "Free up your finance team’s time",
  },
  {
    src: `${VENDOR_PAYMENTS}/DigitalInvoice.png`,
    alt: "img",
    text: "Accurate invoice payments with UTR",
  },
  {
    src: `${VENDOR_PAYMENTS}/reconcilation.png`,
    alt: "img",
    text: "Automated reconciliation",
  },
];

export const vendorListItems = [
  "Tax Payment",
  "Vendor Bill Payment",
  "BBPS Bill Payment",
];

export const steps = [
  {
    imageSrc: `${VENDOR_PAYMENTS}/UploadInvoices.png`,
    imageAlt: "Upload Invoices",
    title: "Upload Invoices",
    description: "Quickly upload invoices, either single or in bulk",
  },
  {
    imageSrc: `${VENDOR_PAYMENTS}/AccountingTools.png`,
    imageAlt: "Sync from Accounting Tools",
    title: "Sync from Accounting Tools",
    description:
      "Seamlessly synchronise account payables with Tally or other accounting tools",
  },
  {
    imageSrc: `${VENDOR_PAYMENTS}/SetApproval.png`,
    imageAlt: "Set Approval workflows",
    title: "Set Approval workflows",
    description:
      "View, initiate and approve invoices with customised approval workflows",
  },
  {
    imageSrc: `${VENDOR_PAYMENTS}/PayInvoices.png`,
    imageAlt: "Pay Invoices",
    title: "Pay Invoices",
    description:
      "Select from a range of payment options for settling invoices conveniently",
  },
  {
    imageSrc: `${VENDOR_PAYMENTS}/reconcilation.png`,
    imageAlt: "Reconcile",
    title: "Reconcile",
    description:
      "Generate comprehensive invoice reports for seamless reconciliation",
  },
];

export const featuresData = [
  {
    videoSrc: `${VENDOR_PAYMENTS}/1StreamlineTrackingWithInvoiceUpload.png`,
    title: "Streamline tracking with invoice upload",
    description:
      "Manage invoices easily by single/bulk upload and keep track of them based on their respective due dates.",
    reverseLayout: false,
    imageAlt: "StreamlineTracking",
  },
  {
    videoSrc: `${VENDOR_PAYMENTS}/2VerifyVendorReceiverIdentityWithEase.png`,
    title: "Verify vendor/receiver identity with ease",
    description:
      "Verify recipient identity (PAN, BAV, Aadhaar, GSTIN) with our KYC (Know Your Customer) & KYB (Know Your Business) features, ensuring seamless transfers with accurate bank account details.",
    reverseLayout: true,
    imageAlt: "VerifyVendorReceiverIdentity",
  },
  {
    videoSrc: `${VENDOR_PAYMENTS}/3RevolutioniseAccountingIntegrationwithTallyandOtherTools.png`,
    title: "Revolutionise accounting integration with Tally and other tools",
    description:
      "Seamlessly sync account payables from Tally or other accounting tools to manage invoices and payments efficiently.",
    reverseLayout: false,
    imageAlt: "RevolutioniseAccounting",
  },
  {
    videoSrc: `${VENDOR_PAYMENTS}/4DiversifyPaymentOptionsForGreaterFlexibility.png`,
    title: "Diversify payment options for greater flexibility",
    description:
      "Provide merchants with flexibility and choice in making payments through various options.",
    reverseLayout: true,
    imageAlt: "DiversifyPayment",
  },
  {
    videoSrc: `${VENDOR_PAYMENTS}/5StrengthenSecurityWithApprovalWorkflows.png`,
    title: "Strengthen security with approval workflows",
    description:
      "Define the 'Approver' role to authorise or reject invoice payments, ensuring control and legitimacy through secure approval workflows.",
    reverseLayout: false,
    imageAlt: "StrengthenSecurity",
  },
  {
    videoSrc: `${VENDOR_PAYMENTS}/6SimplifyReconciliationWithInvoiceReports.png`,
    title: "Simplify reconciliation with invoice reports",
    description:
      "Effortlessly reconcile invoices and payments with comprehensive reports and seamless Tally integration.",
    reverseLayout: true,
    imageAlt: "SimplifyReconciliation",
  },
];

export const pricingData = [
  { id: 0, item: "Dedicated account manager" },
  { id: 1, item: "Volume discounts" },
  { id: 2, item: "Migration support" },
  { id: 3, item: "Dedicated support" },
];
